import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import {StyleSheet, Text, View} from "shared/base"
import {digs} from "diggerize"
import HayaSelect from "components/woof-haya-select"
import {HelperText} from "react-native-paper"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import {useForm} from "@kaspernj/api-maker/build/form"
import useInput from "@kaspernj/api-maker/build/use-input"

const styles = StyleSheet.create({
  label: {color: "#aaa", fontSize: 12},
  labelContainer: {marginLeft: 10}
})

export default memo(shapeComponent(class ComponentsUtilsSelect extends ShapeComponent {
  static defaultProps = {
    multiple: false
  }

  static propTypes = {
    label: PropTypes.string,
    multiple: PropTypes.bool.isRequired,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onChangeSelected: PropTypes.func
  }

  setup() {
    const {inputProps, wrapperOpts} = useInput({props: this.props, wrapperOptions: {type: "input"}})
    const {errors} = digs(wrapperOpts, "errors")
    const {multiple, name, values} = this.props

    this.errors = errors
    this.inputProps = inputProps
    this.form = useForm()

    // Set initial value in form
    useMemo(() => {
      if (this.form && name) {
        let value

        if (multiple) {
          value = values
        } else {
          value = values[0]
        }

        this.form.setValue(name, value)
      }
    }, [])
  }

  render() {
    const {errors, inputProps} = this.tt
    const {label, onChange, onChangeSelected, ...restProps} = this.props

    return (
      <View dataSet={this.dataSet ||= {component: "utils/select", id: inputProps.id, name: inputProps.name}}>
        {label &&
          <View style={styles.textContainer}>
            <Text style={styles.label}>
              {label}
            </Text>
          </View>
        }
        <HayaSelect onChange={this.tt.onSelectChanged} {...restProps} />
        {errors.length > 0 &&
          <HelperText dataSet={this.helperTextDataSet ||= {class: "errors-helper-text"}} type="error">
            {this.errorMessages().join(". ")}
          </HelperText>
        }
      </View>
    )
  }

  errorMessages() {
    const {errors} = this.tt
    const errorMessages = []

    for (const error of errors) {
      for (const errorMessage of error.getErrorMessages()) {
        errorMessages.push(errorMessage)
      }
    }

    return errorMessages
  }

  onSelectChanged = ({options}) => {
    const {form} = this.tt
    const {multiple} = this.p
    const {name, onChange, onChangeSelected} = this.props
    const optionValues = options.map((option) => option.value)

    if (form && name) {
      form.setValue(name, multiple ? optionValues : optionValues[0])
    }

    if (onChange) {
      onChange(multiple ? options : options[0])
    }

    if (onChangeSelected) {
      onChangeSelected(multiple ? optionValues : optionValues[0])
    }
  }
}))
